module.exports = __webpack_public_path__ + "img/logo-centrum-riviera.a1593a2b.svg";